import { styled } from '@rybr/styled-modules'
import React from 'react'

import { useBreakpoints } from '@ntc/hooks/useBreakpoints'

import { BREAK_POINT, Breakpoint } from '@constants/constants.css'

import styles from './ComponentBackdrop.module.scss'

export type ComponentBackdropProps = {
  backdrop?: {
    backgroundColor: string
    heightDesktop: string
    heightTablet: string
    heightMobile: string
  } | null
}
const StyledBackdrop = styled.div<{
  backgroundColor: NonNullable<ComponentBackdropProps['backdrop']>['backgroundColor']
  heightDesktop: NonNullable<ComponentBackdropProps['backdrop']>['heightDesktop']
  heightTablet?: NonNullable<ComponentBackdropProps['backdrop']>['heightTablet']
  heightMobile?: NonNullable<ComponentBackdropProps['backdrop']>['heightMobile']
  breakpoint?: Breakpoint
}>(styles.Backdrop, ({ backgroundColor, heightDesktop, heightTablet, heightMobile, breakpoint }) => ({
  backgroundColor,
  height:
    breakpoint === BREAK_POINT.desktop ? heightDesktop : breakpoint === BREAK_POINT.mobile ? heightMobile : heightTablet
}))

export const ComponentBackdrop: React.FC<ComponentBackdropProps> = ({ backdrop }) => {
  const { backgroundColor, heightDesktop, heightTablet, heightMobile } = backdrop ?? {}
  const breakpoint = useBreakpoints()

  return !backgroundColor || !heightDesktop ? null : (
    <StyledBackdrop
      $backgroundColor={backgroundColor}
      $heightDesktop={heightDesktop}
      $heightTablet={heightTablet}
      $heightMobile={heightMobile}
      $breakpoint={breakpoint}
    />
  )
}
